import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../App.css";
// import Logo from "../assets/images/logo.png";
import Dashboard from "../assets/images/Dashboard.jpg";
import Stores from "../assets/images/Store.png";
import Category from "../assets/images/Categories.png";
import Logo from "../assets/images/bayin.png";
import Order from "../assets/images/Order.png";
import Logout from "../assets/images/Logout.png";
import Report from "../assets/images/report.png";
import Setting from "../assets/images/settings.png";
import BranchIcon from "../assets/images/branch-icon.svg";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { ownerLogout } from "../redux/actions/authAction";
import { setSelectedBranch } from "../redux/actions/storeAction";
import { io } from "socket.io-client";
import { useStore } from "../hooks/useStore";

const SideNav = () => {
  const location = useLocation();
  let pathMatch = location.pathname.split("/")[1] || "";
  console.log("pathMatch", pathMatch);

  const [Logoutshow, setShow] = useState(false);
  const handleLogoutClose = () => setShow(false);
  const handleLogoutShow = () => setShow(true);

  const socketRef = useRef();
  const SOCKET_SERVER_URL = "https://bayin.app:4000";

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("selectedBranchId");
    localStorage.removeItem("selectedBranchName");
    localStorage.removeItem("ownerIsMainBranch");
    localStorage.removeItem("ownerBranchCount");
    dispatch(setSelectedBranch(null, null));
    dispatch(ownerLogout()).then((res) => {
      if (res.status === 200) {
        toast.success(res.message, {
          position: toast.POSITION.TOP_RIGHT,
        });

        socketRef.current = io(SOCKET_SERVER_URL, {
          transports: ["websocket"],
          reconnection: true,
          reconnectionAttempts: Infinity,
          reconnectionDelay: 1000,
          reconnectionDelayMax: 5000,
          randomizationFactor: 0.5,
        });

        socketRef.current.on("disconnect", (reason) => {
          // console.log(`Socket disconnected: ${reason}`);
        });

        //   return () => {
        localStorage.clear();
        navigate("/");
        socketRef.current.disconnect();
        // window.location.reload()
        //   };
      } else {
        toast.error(res.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        localStorage.clear();
        navigate("/");
      }
    });
  };

  const { storeData } = useStore();

  const isMainBranch = storeData?.data?.isMainBranch;
  const branchCount = storeData?.data?.branchCount;

  const showStore = isMainBranch !== false;
  const showBranches = isMainBranch !== false;
  const showProduct = isMainBranch !== false;
  const showReports = isMainBranch !== false;
  const showItems = isMainBranch === false;

  return (
    <div>
      <div className="SidenavArea">
        <figure>
          <img src={Logo} />
        </figure>
        <ul>
          <li className={pathMatch == "dashboard" ? "active" : ""}>
            <Link to="/dashboard">
              <span className="Icon">
                {" "}
                <img src={Dashboard} />
              </span>
              Dashboard
            </Link>
          </li>
          {/* <li className={(pathMatch == "customer-management" || pathMatch == "customer-details" || pathMatch == "customer-add" || pathMatch == "customer-edit") ? "active" : ''}>
                        <Link to="/customer-management">
                            <span className="Icon"> <img src={Customers} /></span>
                             Customers 
                        </Link>
                    </li> */}
          {showStore && (
            <li
              className={
                pathMatch == "my-store" || pathMatch == "edit-my-store"
                  ? "active"
                  : ""
              }
            >
              <Link to="/my-store">
                <span className="Icon">
                  {" "}
                  <img src={Stores} />
                </span>
                Store
              </Link>
            </li>
          )}
          {showBranches && (
            <li
              className={
                pathMatch === "branch-management" ||
                pathMatch === "branch-add" ||
                pathMatch === "branch-edit" ||
                pathMatch === "branch-details"
                  ? "active"
                  : ""
              }
            >
              <Link to="/branch-management">
                <span className="Icon">
                  {" "}
                  <img src={BranchIcon} alt="Branch" />
                </span>
                Branches
              </Link>
            </li>
          )}
          {showItems && (
            <li className={pathMatch == "items" ? "active" : ""}>
              <Link to="/items">
                <span className="Icon">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ verticalAlign: "middle" }}
                  >
                    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                    <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                    <line x1="12" y1="22.08" x2="12" y2="12"></line>
                  </svg>
                </span>
                Items
              </Link>
            </li>
          )}
          {showProduct && (
            <li
              className={
                pathMatch == "product-management" ||
                pathMatch == "product-add" ||
                pathMatch == "product-edit"
                  ? "active"
                  : ""
              }
            >
              <Link to="/product-management">
                <span className="Icon">
                  {" "}
                  <img src={Category} />
                </span>
                Product
              </Link>
            </li>
          )}

          <li
            className={
              pathMatch == "order-management" || pathMatch == "order-details"
                ? "active"
                : ""
            }
          >
            <Link to="/order-management">
              <span className="Icon">
                {" "}
                <img src={Order} />
              </span>
              Order
            </Link>
          </li>
          <li className={pathMatch == "setting" ? "active" : ""}>
            <Link to="/setting">
              <span className="Icon">
                {" "}
                <img src={Setting} />
              </span>
              Settings
            </Link>
          </li>
          {showReports && (
            <li className={pathMatch == "Report-management" ? "active" : ""}>
              <Link to="/Report-management">
                <span className="Icon">
                  {" "}
                  <img src={Report} />
                </span>
                Reports
              </Link>
            </li>
          )}
          <li className={pathMatch == "" ? "active" : ""}>
            <a
              href="#!"
              onClick={(e) => {
                e.preventDefault();
                handleLogoutShow();
              }}
            >
              <span className="Icon">
                {" "}
                <img src={Logout} />
              </span>
              Logout
            </a>
          </li>
        </ul>
      </div>
      <div>
        <Modal
          show={Logoutshow}
          onHide={handleLogoutClose}
          className="ModalBox "
        >
          <Modal.Body>
            <div className="Decline">
              <button className="CloseModal" onClick={handleLogoutClose}>
                ×
              </button>
              <h3>Logout</h3>
              <figure>
                <img src={Logout} />
              </figure>
              <p>Are you sure you want to Logout this Panel?</p>
              <h4>
                <button className="Cancel" onClick={handleLogoutClose}>
                  Cancel
                </button>
                <button onClick={() => handleLogout()}>Logout</button>
              </h4>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};
export default SideNav;
